define([], () => {

    return () => {

        return () => { // NOSONAR
        };
    };
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/tracking/adapters/eTracker.js